/**
 * RFC-163 — Legacy connect-tools route.
 *
 * The Connect Tools step was retired; its surface moved inside the
 * onboarding wizard as the Connect Stage (RFC-213: the `connectIdp`
 * per-type connect step, first of the essential connect sequence).
 * Any leftover deep links, bookmarks, or phase-redirect targets that
 * still point at this URL bounce into the wizard with the right step
 * selected.
 */
import { useEffect } from 'react'
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'
import PageLoading from '@/components/PageLoading'
import ForbiddenError from '@/pages/errors/forbidden'
import { useWorkspacePermissions } from '@/hooks/useWorkspacePermissions'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/connect-tools',
)({
  component: ConnectToolsRedirect,
})

function ConnectToolsRedirect() {
  const { workspaceId } = useParams({
    from: '/(protected)/workspaces/$workspaceId/connect-tools',
  })
  const navigate = useNavigate()
  const { isAdmin, isLoading } = useWorkspacePermissions(workspaceId)

  useEffect(() => {
    if (!isAdmin) return
    void navigate({
      to: '/workspaces/$workspaceId/onboarding',
      params: { workspaceId },
      search: { step: 'connectIdp' },
      replace: true,
    })
  }, [isAdmin, navigate, workspaceId])

  if (isLoading) return <PageLoading />
  if (!isAdmin) return <ForbiddenError />
  return <PageLoading />
}
